module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-45.1ee0493e.png";